/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, Input } from '@angular/core';
import { Tour } from '@shared/models';

@Component({
    selector: 'app-tour-item-progress',
    templateUrl: './tour-item-progress.component.html',
    styleUrls: ['./tour-item-progress.component.scss'],
    standalone: false
})
export class TourItemProgressComponent {

  @Input() tour: Tour;

  constructor() { }

}
